import { useEffect, useState } from 'react';
import { useAwmsStore } from '@/store';
import {
  useFilterWorkloadData,
  useHandleError,
  useSchoolList,
  useSchoolsFilteredByUser,
  useSchoolUnitDetails,
  useUnitWorkloadList,
} from '@/hooks';
import { updateFilters } from './utils/updateFilters';

export const useSchoolUnitData = () => {
  const handleError = useHandleError();
  const activeYear = useAwmsStore((state) => state.activeYear);
  const selectedSchoolId = useAwmsStore((state) => state.selectedSchoolId);
  const setSelectedSchoolId = useAwmsStore((state) => state.setSelectedSchoolId);
  const selectedStudyPeriodId = useAwmsStore((state) => state.selectedStudyPeriodId);
  const setSearchFilters = useAwmsStore((state) => state.setSearchFilters);
  const searchFilters = useAwmsStore((state) => state.searchFilters);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const {
    data: schoolList = [],
    isLoading: isSchoolListLoading,
    error: schoolListError,
  } = useSchoolsFilteredByUser(activeYear);
  const { studyPeriodList, disciplineList, isFilterWorkloadDataLoading } = useFilterWorkloadData(selectedSchoolId);

  useEffect(() => {
    if (!selectedSchoolId && schoolList) {
      updateFilters(schoolList, selectedSchoolId, activeYear, searchFilters, setSelectedSchoolId, setSearchFilters);
    }
  }, [selectedSchoolId, schoolList, activeYear, setSearchFilters]);

  const {
    data: schoolUnitDetails,
    isLoading: isSchoolUnitDetailsLoading,
    error: schoolUnitDetailsError,
  } = useSchoolUnitDetails(activeYear, selectedSchoolId, selectedStudyPeriodId);

  const {
    data: unitWorkloadList,
    isLoading: isUnitWorkloadLoading,
    error: unitWorkloadListError,
  } = useUnitWorkloadList();

  useEffect(() => {
    if (schoolListError || schoolUnitDetailsError || unitWorkloadListError) {
      console.error('Error fetching data:', { schoolListError, schoolUnitDetailsError, unitWorkloadListError });
    }
    handleError([schoolListError, schoolUnitDetailsError, unitWorkloadListError]);
  }, [schoolListError, schoolUnitDetailsError, unitWorkloadListError, handleError]);

  useEffect(() => {
    setIsPageLoading(
      isSchoolListLoading || isSchoolUnitDetailsLoading || isUnitWorkloadLoading || isFilterWorkloadDataLoading,
    );
  }, [isSchoolListLoading, isSchoolUnitDetailsLoading, isUnitWorkloadLoading, isFilterWorkloadDataLoading]);

  return {
    schoolList,
    studyPeriodList,
    disciplineList,
    schoolUnitDetails,
    unitWorkloadList,
    isPageLoading,
  };
};
